import jwtAuthAxios from "../auth/jwtAuth";

const deviceServices = {};

deviceServices.getNewDevice = async (params) => {
    const {data} = await jwtAuthAxios.get(`/automations/devices/new${params ?? ""}`);
    return data;
}

deviceServices.createDevice = async (params, body) => {
    const {data} = await jwtAuthAxios.post(`/automations/devices${params ?? ""}`, body);
    return data;
}

deviceServices.getDevices = async (params) => {
    const {data} = await jwtAuthAxios.get(`/automations/devices${ params ?? ""}`);
    return data;
};

deviceServices.getDevice = async (id, params) => {
    const {data} = await jwtAuthAxios.get(`/automations/devices/${id}${ params ?? ""}`);
    return data;
};

deviceServices.getEditOptions = async (deviceId) => {
    const path = deviceId ? `/automations/devices/edit_options?device_id=${deviceId}` : `/automations/devices/edit_options`;
    const {data} = await jwtAuthAxios.get(path);
    return data;
};

// Series históricas de todas las variables del dispositivo, para la ficha de detalle.
deviceServices.getDeviceSeries = async (deviceId, range) => {
    const query = range ? `?range=${encodeURIComponent(range)}` : "";
    const {data} = await jwtAuthAxios.get(`/automations/devices/${deviceId}/series${query}`);
    return data;
};

deviceServices.updateDevice = async (deviceId, params='', body) => {
    const {data} = await jwtAuthAxios.put(`/automations/devices/${deviceId}${params}`, body);
    return data;
};

// Salidas controlables (puntos de un equipo actuador): estado, control manual con vencimiento y estado seguro. El control
// «Mantener en rango» que la maneja se edita en Automatizaciones (control-loop-services).
deviceServices.getActuator = async (deviceId) => {
    const {data} = await jwtAuthAxios.get(`/automations/actuators/${deviceId}`);
    return data;
};

deviceServices.holdActuator = async (deviceId, state, minutes) => {
    const {data} = await jwtAuthAxios.post(`/automations/actuators/${deviceId}/hold`, { state, minutes });
    return data;
};

deviceServices.releaseActuator = async (deviceId) => {
    const {data} = await jwtAuthAxios.post(`/automations/actuators/${deviceId}/release`);
    return data;
};

deviceServices.updateActuatorFailSafe = async (deviceId, failSafeState) => {
    const {data} = await jwtAuthAxios.put(`/automations/actuators/${deviceId}`, { fail_safe_state: failSafeState || "" });
    return data;
};

deviceServices.clearActuatorLockout = async (deviceId) => {
    const {data} = await jwtAuthAxios.post(`/automations/actuators/${deviceId}/clear_lockout`);
    return data;
};

export default deviceServices;
